<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">

        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card>
                  <v-card-text class="pt-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">analytics</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n['reports_about_your_orders'] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['reports_about_your_orders'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fromDate"
                                  :label="i18n['from_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  outlined
                                  hide-details
                                  dense
                                  :disabled="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="fromDate"
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="toDate"
                                  :label="i18n['to_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  hide-details
                                  outlined
                                  :disabled="loading"
                                  dense
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="toDate"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-autocomplete
                              :items="resource.statuses"
                              v-model="selectedStatus"
                              :label="i18n.status"
                              autocomplete="disabled"
                              outlined
                              hide-details
                              clearable
                              dense
                              :disabled="loading"
                              :loading="loading"
                              prepend-icon="task_alt"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{statuses_obj[item.name] ? statuses_obj[item.name][language] : ''}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{statuses_obj[item.name] ? statuses_obj[item.name][language] : item}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu3"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fromOutDate"
                                  :label="i18n['out_for_delivery_date_from']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  outlined
                                  hide-details
                                  dense
                                  :disabled="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="fromOutDate"
                                @input="menu3 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu4"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="toOutDate"
                                  :label="i18n['out_for_delivery_date_to']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  hide-details
                                  outlined
                                  :disabled="loading"
                                  dense
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="toOutDate"
                                @input="menu4 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center py-1"  v-if="isMasterUser" FILTER>
                            <v-autocomplete
                              :items="resource.accounts"
                              v-model="selectedAccountId"
                              :label="i18n['report_for_account']"
                              prepend-icon="mdi-account"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              :disabled="loading"
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item.name}} | {{item.id}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item.name}} | {{item.id}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center py-1" FILTER>
                            <v-autocomplete
                              :items="countries"
                              v-model="selectedCountry"
                              :label="i18n['country']"
                              autocomplete="disabled"
                              prepend-icon="mdi-earth"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              :disabled="loading"
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{label_[language][item.alpha2Code]}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{label_[language][item.alpha2Code]}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="3" class="text-center py-1" FILTER>
                            <v-autocomplete
                              :items="resource.skus"
                              v-model="selectedSku"
                              prepend-icon="mdi-tag"
                              :label="i18n['product']"
                              autocomplete="disabled"
                              outlined
                              @click.stop=""
                              :filter="filterObject"
                              hide-details
                              clearable
                              :disabled="loading"
                              dense
                              :loading="loading"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{item}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{item}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>

                          <v-col cols="12" md="3" class="text-center py-1" FILTER>
                            <v-switch
                                hide-details inset
                                :class="`${arabic?'arFont':'enFont'} mt-0`"
                                :label="i18n['manjam_ninja_orders']"
                                v-model="onlyManjam">
                            </v-switch>
                            </v-col>
                          <v-col cols="12" md="6" class="text-center py-0" BTN>
                            <v-btn
                              color="primary"
                              block
                              :disabled="loading"
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              @click="init()">
                              {{ i18n['load_report'] }}
                              <v-icon right size="15">analytics</v-icon>
                              <div
                                right
                                v-if="main_results.time"
                                style="font-size:11px;direction:ltr!important;"
                                :class="`${arabic?'arFont':'enFont'} white--text pr-3`">
                                {{(main_results.time * 1000 ).toFixed(0)}}  ms
                              </div>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="6" class="text-center py-0" BTN>
                            <v-btn
                              color="primary"
                              block
                              :disabled="loading"
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              @click="exportLeads">
                              {{ i18n['export_report'] }}
                              <v-icon right size="15">file_download</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-row class="">
                  <v-col cols="12" md="3">
                    <v-card :loading="loading" class="statCard">
                      <v-card-text>
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                          {{ i18n['total_orders'] }}
                        </div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ numberWithCommas(main_results.total) }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:12px;font-weight:700;">{{ numberWithCommas(main_results.last_month) }} {{ i18n['orders_in_last_30_days'] }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-card :loading="loading" class="statCard">
                      <v-card-text>
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">{{ i18n['profits'] }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">${{ numberWithCommas(main_results.ready_total) }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:12px;font-weight:700;">{{ numberWithCommas(main_results.ready_count) }} {{ i18n['order'] }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-card :loading="loading" class="statCard">
                      <v-card-text>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} pb-2`" style="font-size:16px;">{{ i18n['invoices_total'] }}</div>
                        <div v-if="main_results.subvendor_total_fees" :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:22px;font-weight:700;">${{ numberWithCommas(main_results.subvendor_total_fees) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-card :loading="loading" class="statCard">
                      <v-card-text>
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">{{ i18n['confirmation_rate'] }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">%{{ main_results.confirm_rate }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:12px;font-weight:700;">{{ numberWithCommas(main_results.confirm_count) }} {{ i18n['order'] }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-card :loading="loading" class="statCard">
                      <v-card-text>
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">{{ i18n['delivery_rate'] }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">%{{ main_results.delivery_rate }}</div>
                        <div v-if="main_results.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:12px;font-weight:700;">{{ numberWithCommas(main_results.delivered_count) }} {{ i18n['order'] }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="12" v-if="isMasterUser">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">{{ i18n['statistics_for_accounts_orders'] }}</div>
                    <v-spacer></v-spacer>
                    <span color="primary" :class="`${arabic?'arFont':'enFont'} pr-3`" style="font-size:15px;font-weight:700;">
                      {{ i18n['total'] }}: {{ leadsCountByAccount.length }}
                    </span>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                    <v-col cols="12" md="6" v-for="leadCount in leadsCountByAccount.slice(0, totalLeadsToShow)" :key="leadCount.account_id">
                      <AccountOrdersStats :item="leadCount"/>
                    </v-col>
                    </v-row>
                  </v-card-text>
                <v-card-actions :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <v-spacer></v-spacer>
                    <v-btn color="success" text :class="`${arabic ? 'arFont' : 'enFont'}`"
                    @click="loadMoreLeadsHandler" v-if="canLoadMoreLeads">
                    {{ i18n['show_more'] }}
                    </v-btn>
                </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['orders_distribution_by_current_status'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="success" icon @click="loadByStatus()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="by_status.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(by_status.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                          {{ i18n['total_orders'] }}
                        </div>
                        <div v-if="by_status.total && by_status.total.count" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ by_status.total.count }}</div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <apexchart width="100%" type="bar" :options="getOptions(by_status, 1)" :series="getSeries(by_status)"></apexchart>
                      </v-col>
                      <v-col cols="12" md="6">
                        <apexchart width="100%" type="donut" :options="getOptions(by_status, 2)" :series="getSeries(by_status)[0].data"></apexchart>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-1`">
                        {{ i18n['average_profit_per_order'] }}
                        <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`" small>${{by_status.avg_profit_per_order}}</v-chip>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-1`">
                        {{ i18n['expected_confirmation_rate'] }}
                        <v-chip label :class="`${arabic?'arFont':'enFont'}`" small>{{by_status.expected}}%</v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['order_distribution_by_country'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="loadByCountry()" :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ i18n['load_report'] }}
                    </v-btn>
                    <v-btn color="success" icon @click="loadByCountry()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="by_country.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(by_country.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                          {{ i18n['total_orders'] }}
                        </div>
                        <div v-if="by_country.total && by_country.total.count" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ by_country.total.count }}</div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <apexchart width="100%" type="treemap" :options="getOptions(by_country, 3)" :series="getSeriesPairs(by_country)"></apexchart>
                      </v-col>
                      <v-col cols="12" md="6">
                        <apexchart width="100%" type="donut" :options="getOptions(by_country, 4)" :series="getSeries(by_country)[0].data"></apexchart>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['status_and_delivery_rates_per_country'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="loadSkusByCountry()" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ i18n['load_report'] }}
                    </v-btn>
                    <v-btn color="success" icon @click="loadSkusByCountry()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="skus_by_country.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(skus_by_country.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-tabs
                          v-model="skuCountryTab"
                          background-color="primary"
                          center-active
                          fixed-tabs
                          dark
                        >
                          <v-tab v-for="(label, l) in getCountryLabels(skus_by_country)" :key="l+'tab'" :class="`${arabic?'arFont':'enFont'}`">{{label}}</v-tab>
                        </v-tabs>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-tabs-items v-model="skuCountryTab">
                          <v-tab-item
                            v-for="(result, i) in skus_by_country.results"
                            :key="i + 'sku-country-result'"
                          >
                            <v-card flat>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="12" md="6">
                                    <apexchart width="100%" type="donut" :options="getOptions(result.by_status, 5)" :series="getShippingSeriesPairs(result.by_status)"></apexchart>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <apexchart width="100%" type="donut" :options="getOptions(result.by_shipping_status, 5)" :series="getShippingSeriesPairs(result.by_shipping_status)"></apexchart>
                                  </v-col>
                                  <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-1`">
                                    {{ i18n['average_profit_per_order'] }}
                                    <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`" small>${{result.by_status.avg_profit_per_order}}</v-chip>
                                  </v-col>
                                  <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-1`">
                                    {{ i18n['expected_confirmation_rate'] }}
                                    <v-chip label :class="`${arabic?'arFont':'enFont'}`" small>{{result.by_status.expected}}%</v-chip>
                                  </v-col>

                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['the_10_best_seller_products_in_each_country'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="success" icon @click="loadSkusByCountry()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="skus_by_country.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(skus_by_country.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-tabs
                          v-model="skuCountryTab"
                          background-color="primary"
                          center-active
                          fixed-tabs
                          dark
                        >
                          <v-tab v-for="(label, l) in getCountryLabels(skus_by_country)" :key="l+'tab'" :class="`${arabic?'arFont':'enFont'}`">{{label}}</v-tab>
                        </v-tabs>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-tabs-items v-model="skuCountryTab">
                          <v-tab-item
                            v-for="(result, i) in skus_by_country.results"
                            :key="i + 'sku-country-result'"
                          >
                            <v-card flat>
                              <v-card-text>
                                <v-row>
                                  <v-col cols="12" md="12">
                                    <apexchart width="100%" type="bar" :height="250" :options="getOptions(result.lead_sku.group_by_sku, 4, 250)" :series="getSkuCountrySeriesPairs(result.lead_sku.group_by_sku)"></apexchart>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['best_seller_products_statuses_and_delivery_rate'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="success" icon @click="loadSkusStatusByCountry()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="skus_by_status_country.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(skus_by_status_country.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="align-center">
                      <v-col cols="12" md="4" class="text-center py-1" BTN>
                        <div :class="`${arabic?'arFont':'enFont'}`">
                          {{ i18n['pick_a_country_to_load_report'] }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4" class="text-center py-1" BTN>
                        <v-autocomplete
                          :items="countries"
                          v-model="selectedCountry"
                          :label="i18n['country']"
                          autocomplete="disabled"
                          outlined
                          prepend-icon="mdi-earth"
                          @click.stop=""
                          :filter="filterObject"
                          hide-details
                          clearable
                          :disabled="loading"
                          dense
                          :loading="loading"
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{label_[language][item.alpha2Code]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{label_[language][item.alpha2Code]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" class="text-center py-1" BTN>
                        <v-btn
                          color="primary"
                          block
                          :disabled="loading"
                          :loading="loading"
                          :class="`${arabic?'arFont':'enFont'}`"
                          @click="loadSkusStatusByCountry()">
                          {{ i18n['load_report'] }}
                          <v-icon right size="15">analytics</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row v-if="selectedCountry">
                          <v-col cols="12" md="12">
                            <apexchart width="100%" height="250px;" type="bar" :options="getStackOptions(skus_by_status_country, 8, '250px')" :series="getSkuShippingStacked(skus_by_status_country)"></apexchart>
                          </v-col>
                          <v-col cols="12" md="12">
                            <apexchart width="100%" height="250px;" type="bar" :options="getStackOptions(skus_by_status_country, 8, '250px')" :series="getSkuStatusStacked(skus_by_status_country)"></apexchart>
                          </v-col>

                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card :loading="loading" class="statCard">
                  <v-card-title>
                    <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:700;">
                      {{ i18n['calculate_expected_profit_by_product'] }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="success" icon @click="calculateExpectedProfit()">
                      <v-icon>replay</v-icon>
                    </v-btn>
                    <div
                      right
                      v-if="expected_profit.time"
                      style="font-size:11px;direction:ltr!important;"
                      :class="`${arabic?'arFont':'enFont'} pr-3`">
                      {{(expected_profit.time * 1000 ).toFixed(0)}}  ms
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="align-center">
                      <v-col cols="12" md="3" class="text-center py-1" BTN>
                        <div :class="`${arabic?'arFont':'enFont'}`">
                          {{ i18n['pick_a_country_and_a_product_to_load_report'] }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="3" class="text-center py-1" FILTER>
                        <v-menu
                          v-model="menu5"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="expectedProfitFilter.fromDate"
                              :label="i18n['from_date']"
                              prepend-icon="mdi-calendar"
                              readonly
                              :loading="loading"
                              outlined
                              hide-details
                              dense
                              :disabled="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              clearable
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="expectedProfitFilter.fromDate"
                            @input="menu5 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="3" class="text-center py-1" FILTER>
                        <v-menu
                          v-model="menu6"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="expectedProfitFilter.toDate"
                              :label="i18n['to_date']"
                              prepend-icon="mdi-calendar"
                              readonly
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                              hide-details
                              outlined
                              :disabled="loading"
                              dense
                              clearable
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="expectedProfitFilter.toDate"
                            @input="menu6 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="3" class="text-center py-1" FILTER>
                        <v-autocomplete
                          :items="countries"
                          v-model="selectedCountry"
                          :label="i18n['country']"
                          autocomplete="disabled"
                          outlined
                          prepend-icon="mdi-earth"

                          @click.stop=""
                          :filter="filterObject"
                          hide-details
                          clearable
                          :disabled="loading"
                          dense
                          :loading="loading"
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{label_[language][item.alpha2Code]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{label_[language][item.alpha2Code]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3" class="text-center py-1" FILTER>
                        <v-autocomplete
                          :items="resource.skus"
                          v-model="selectedSku"
                          prepend-icon="mdi-tag"
                          :label="i18n['product']"
                          autocomplete="disabled"
                          outlined
                          @click.stop=""
                          :filter="filterObject"
                          hide-details
                          clearable
                          :disabled="loading"
                          dense
                          :loading="loading"
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{item}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{item}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="text-center py-1" BTN>
                        <v-btn
                          color="primary"
                          block
                          :disabled="loading"
                          :loading="loading"
                          :class="`${arabic?'arFont':'enFont'}`"
                          @click="calculateExpectedProfit()">
                          {{ i18n['load_report'] }}
                          <v-icon right size="15">analytics</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row v-if="expected_profit.time">
                          <v-col cols="12" md="3">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['total_orders'] }}
                                </div>
                                <div v-if="expected_profit.total" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ numberWithCommas(expected_profit.total) }}</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['net_profit'] }}
                                </div>
                                <div v-if="expected_profit.avg_profit_per_order" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">${{ numberWithCommas(expected_profit.avg_profit_per_order) }}</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['expected_confirm_rate'] }}
                                </div>
                                <div v-if="expected_profit.expected" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ numberWithCommas(expected_profit.expected) }}%</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['expected_delivery_rate'] }}
                                </div>
                                <div v-if="expected_profit.expected_delivered" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">{{ numberWithCommas(expected_profit.expected_delivered) }}%</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-card :loading="loading" color="primary" dark>
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['total_expected_profit'] }}
                                </div>
                                <div v-if="expected_profit.expected_profit" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;color:#fff;">${{ numberWithCommas(expected_profit.expected_profit) }}</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <v-text-field
                                  v-model="ad_spend"
                                  :class="`${arabic?'arFont':'enFont'} py-1`"
                                  :label="i18n['total_ad_spend_in_usd']"
                                  outlined
                                  dense
                                  clearable
                                  hide-details
                                >
                                </v-text-field>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-card :loading="loading" class="statCard">
                              <v-card-text>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                                  {{ i18n['net_profit'] }}
                                </div>
                                <div v-if="expected_profit.expected_profit" :class="`${arabic?'arFont':'enFont'}`" style="font-size:22px;font-weight:700;">${{ numberWithCommas(parseInt(expected_profit.expected_profit) - parseInt(ad_spend)) }}</div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import json2csv from 'json2csv';
import axios from 'axios';
import languageMixins from '@/mixings/language';
import userMixins from '@/mixings/user';
import AccountOrdersStats from '@/components/AccountOrdersStats';

export default {
  components: { AccountOrdersStats },

  mixins: [languageMixins, userMixins],

  data() {
    return {
      loading: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n.required,
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n.valid_email,
      },
      resourceKeys: [

      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      countries: [],
      selectedCountry: null,
      selectedPanel: 'firstPanel',
      label_: {

      
        ar:  {
          Human: 'طلبات ملغاة',
          confirmed: 'طلبات مؤكدة',
          noAnswer: 'لا رد',
          nonHuman: 'طلبات خطأ',
          JO: 'الاردن',
          MA: 'المغرب',
          QA: 'قطر',
          SA: 'السعودية',
          KW: 'الكويت',
          BH: 'البحرين',
          LY: 'ليبيا',
          IQ: 'العراق',
          EG: 'مصر',
          AE: 'الامارات',
          PS: 'فلسطين',
          OM: 'عمان',
          LB: 'لبنان',
          SN: 'السنغال',
          CI: 'ساحل العاج',
          MR: 'موريتانيا',
          'Out for delivery': 'قيد التوصيل',
          Returned: 'تم الارجاع',
          'pre return': 'قيد الارجاع',
          special_delivered: 'تم التسليم',
          'under return Process': 'قيد اعادة الطلب'
        },
        en: {
          Human: 'Canceled Order',
          confirmed: 'Confirmed Order',
          noAnswer: "No Answer",
          nonHuman: "Wrong Orders",
          JO: 'Jordan',
          MA: 'Morocco',
          QA: 'Qatar',
          SA: 'Saudi Arabia',
          KW: 'Kuwait',
          BH: 'Bahrain',
          LY: 'Libya',
          IQ: 'Iraq',
          EG: 'Egypt',
          AE: 'United Arab Emirates',
          PS: 'Palestine',
          OM: 'Oman',
          LB: 'Lebanon',
          SN: 'Senegal',
          CI: "Côte d'Ivoire",
          MR: 'Mauritania',
          'Out for delivery': "Out For Delivery",
          Returned: 'Returned',
          'pre return': "Pre Return",
          special_delivered: "Delivered",
          'under return Process': "Under Return Process"
        }
      },
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      fromDate: new Date().toISOString().split('T')[0],
      toDate: new Date().toISOString().split('T')[0],
      fromOutDate: null,
      toOutDate: null,
      statuses: [],
      selectedStatus: null,
      main_results: {},
      time: 0,
      ad_spend: 0,
      by_status: {},
      by_country: {},
      skus_by_country: {},
      selectedAccountId: null,
      skuCountryTab: null,
      selectedSku: null,
      delivered_from: null,
      delivered_to: null,
      skus_by_status_country: {},
      expected_profit: {},
      onlyManjam: false,
      expectedProfitFilter: {
        fromDate: null,
        toDate: null,
      },
      leadsCountByAccount: [],
      totalLeadsToShow: 10, // total lead items to show
    };
  },
  
  methods: {
    getCountryLabels() {
      return this.skus_by_country.results ? this.skus_by_country.results.map((x) => this["label_"][this.language][x.label]) : [];
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getAR(item) {
      return this["label_"][this.language][item] ? this["label_"][this.language][item] : item;
    },
    getOptions(data, id, height = 'auto') {
      const labels = data.results && data.results.length ? data.results.filter((x) => x.count > 0).map((x) => this.getAR(x.label)) : []; // ?this["label_" + this.language][x.label]:x.label
      return {
        labels,
        grid: {
          show: false,
          padding: {
            right: 60,
          },
        },
        xaxis: {
          categories: labels,
        },
        yaxis: {
          opposite: true,

        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontFamily: 'Tajawal, sans-serif',
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: false,
            columnWidth: '90%',
          },
          pie: {
            donut: {
              size: '30%',
            },
          },
          treemap: {
            enableShades: false,
            shadeIntensity: 0,
            reverseNegativeShade: true,
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 1000,
                  color: '#CD363A',
                },
                {
                  from: 1000,
                  to: 10000,
                  color: '#d91022',
                },
                {
                  from: 10000,
                  to: 100000,
                  color: '#be202e',
                },
              ],
            },
          },
        },
        chart: {
          fontFamily: 'Tajawal, sans-serif',
          id,
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
          animations: {
            speed: 200,
          },
          toolbar: {
            show: true,
          },
          height,
          // sparkline: {
          //   enabled: true,
          // }
        },
        theme: {
          palette: 'palette7',
        },
        fill: {
          type: 'gradient',
          pattern: {
            style: 'verticalLines',
            width: 6,
            height: 6,
            strokeWidth: 6,
          },
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.2,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 100],
            colorStops: [],
          },
        },
        legend: {
          fontSize: '14px',
          markers: {
            offsetX: 5,
          },
          onItemClick: {
            toggleDataSeries: true,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
      };
    },
    getStackOptions(data, id, height = '250px') {
      const labels = data.results ? data.results.lead_sku.results.map((x) => x.label) : [];
      return {
        labels,
        grid: {
          show: false,
          padding: {
            right: 60,
          },
        },
        xaxis: {
          categories: labels,
        },
        yaxis: {
          opposite: true,

        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontFamily: 'Tajawal, sans-serif',
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {

            },
          },
        },
        chart: {
          fontFamily: 'Tajawal, sans-serif',
          id,
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
          animations: {
            speed: 200,
          },
          toolbar: {
            show: true,
          },
          height,
          type: 'bar',
          stacked: true,
          stackType: '100%',
          // sparkline: {
          //   enabled: true,
          // }
        },
        theme: {
          palette: 'palette7',
        },
        fill: {
          type: 'gradient',
          pattern: {
            style: 'verticalLines',
            width: 6,
            height: 6,
            strokeWidth: 6,
          },
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.2,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 100],
            colorStops: [],
          },
        },
        legend: {
          fontSize: '14px',
          markers: {
            offsetX: 5,
          },
          onItemClick: {
            toggleDataSeries: true,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
      };
    },
    getSkuShippingStacked(data) {
      if (!data.results || !data.results.lead_sku) return [];
      const labels_shipping = data.results.lead_sku.results[0].by_shipping_status.results.map((x) => this["label_"][this.language][x.label]);
      const skus = data.results.lead_sku.results.map((x) => x.label);
      const counts = data.results.lead_sku.results.map((x) => x.by_shipping_status.results.map((y) => y.count));
      const preped = [];
      for (let i = 0; i < labels_shipping.length; i++) {
        const label = labels_shipping[i];
        preped.push({ name: label, data: data.results.lead_sku.results.map((x) => x.by_shipping_status.results[i].count) });
      }

      return preped;
    },
    getSkuStatusStacked(data) {
      if (!data.results || !data.results.lead_sku) return [];
      const labels = data.results.lead_sku.results[0].by_status.results.map((x) => this["label_"][this.language][x.label]);
      const skus = data.results.lead_sku.results.map((x) => x.label);
      const counts = data.results.lead_sku.results.map((x) => x.by_status.results.map((y) => y.count));
      const preped = [];
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        preped.push({ name: label, data: data.results.lead_sku.results.map((x) => x.by_status.results[i].count) });
      }

      return preped;
    },
    getSkuCountrySeriesPairs(data) {
      const v = data.map((x) => ({
        x: `${x.sku}`, y: x.total_count,
      }));
      return [{
        name: this.i18n['orders_count'],
        data: v,
      }];
    },
    getShippingSeriesPairs(data) {
      return data.results && data.results.length ? data.results.filter((x) => x.count > 0).map((x) => x.count) : [];
    },
    getSeriesPairs(data) {
      const values = data.results && data.results.length ? data.results.filter((x) => x.count > 0).map((x) => ({
        x: `${this.getAR(x.label)} ${x.count}`, y: x.count,
      })) : [];
      return [{
        name: this.i18n['orders_count'],
        data: values,
      }];
    },
    getSeries(data) {
      const values = data && data.results && data.results.length ? data.results.filter((x) => x.count > 0).map((x) => x.count) : [];
      return [{
        name: this.i18n['orders_count'],
        data: values,
      }];
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true;
      return a;
    },
    getSnack(text, color) {
      this.$emit('snackbarNotification', text, color);
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', 'Copied', 'success');
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', 'Failed', 'error');
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('postResource', { resource: `${this.$route.path}/search?page=${n}`, value: this.search });
        }
        this.loading = false;
      });
    },
    goTo(path) {
      this.$router.push(path).catch(() => {});
    },
    buildFilter({ expectedProfit } = {}) {
      let filter = '';

      if (expectedProfit) {
        const { fromDate, toDate } = this.expectedProfitFilter;
        if (fromDate && toDate) {
          filter += `&filter[from]=${fromDate}&filter[to]=${toDate}`;
        }
      }
      if (!expectedProfit) {
        if (this.fromDate && this.toDate) {
          filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`;
        }
      }

      if (this.delivered_from && this.delivered_to) {
        filter += `&filter[delivered_from]=${this.delivered_from}&filter[delivered_to]=${this.delivered_to}`;
      }
      if (this.fromOutDate && this.toOutDate) {
        filter += `&filter[out_delivery_from]=${this.fromOutDate}&filter[out_delivery_to]=${this.toOutDate}`;
      }
      if (this.selectedStatus) {
        filter += `&filter[status]=${this.selectedStatus}`;
      }
      if (this.selectedCountry) {
        filter += `&filter[country_id]=${this.selectedCountry}`;
      }
      if (this.selectedAccountId) {
        filter += `&filter[account_id]=${this.selectedAccountId}`;
      }
      if (this.selectedSku) {
        filter += `&filter[sku]=${this.selectedSku}`;
      }
      if (this.onlyManjam) {
        filter += `&filter[only_manjam]=${this.onlyManjam}`;
      }
      return filter;
    },
    async filterLeads() {
      // console.log('filterLeads')
      await this.loadResource();
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: `${this.$route.path}?${this.buildFilter()}` });
          // console.log(this.resource)
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', { resource: `${this.$route.path}-search?${this.buildFilter()}`, value: { search: this.search } });
        }
        this.loading = false;
        res();
      });
    },
    async exportResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const exp = await this.$store.dispatch('getResource', { resource: '/leads-export' + `?${this.buildFilter()}` });
        this.exportSimpleData(exp, 'leads');
        this.loading = false;
        res();
      });
    },
    exportSimpleData(data, name) {
      const a = json2csv.parse(data);
      // console.log(a)
      const csvContent = 'data:text/csv;charset=utf-8,';
      const encodedUri = csvContent + encodeURIComponent(a);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      const n = name || 'failed_export';
      link.setAttribute('download', `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v) {
      this[v] = true;
      const all = this.subitems.map((x) => x.value);
      all.filter((x) => x != v).forEach((x) => this[x] = false);
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },
    async loadByStatus() {
      return new Promise(async (res, rej) => {
        const r = await axios.get(`https://yervip.com/api/v1/leads-reports/aggregate_count_by_status?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        this.by_status = r;
        res(true);s
      });
    },
    async loadByCountry() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        // api.

        const r = await axios.get(`//yervip.com/api/v1/leads-reports/aggregate_count_by_country?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        this.by_country = r;
        this.loading = false;
        res(true);
      });
    },
    async loadSkusByCountry() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        // api.

        const r = await axios.get(`//yervip.com/api/v1/leads-reports/aggregate_lead_sku_by_country?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        r.results = r.results.filter((x) => x.count > 0);
        this.skus_by_country = r;
        this.loading = false;
        res(true);
      });
    },
    async loadSkusStatusByCountry() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        // api.
        const r = await axios.get(`//yervip.com/api/v1/leads-reports/aggregate_sku_by_status_by_country?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        this.skus_by_status_country = r;
        this.loading = false;
        res(true);
      });
    },
    async loadCountries(countries) {
      return new Promise(async (res, rej) => {
        this.countries = countries.map((x) => ({
          ...x,
          ar: this["label_"][this.language][x.alpha2Code.toLowerCase()],
        }));
        res(true);
      });
    },
    async calculateExpectedProfit() {
      return new Promise(async (res, rej) => {
        const r = await axios.get(`https://yervip.com/api/v1/leads-reports/calculate_expected_profit?${this.buildFilter({ expectedProfit: true })}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        this.expected_profit = r || {};
        res(true);
      });
    },
    async init() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.setResourceName();
        const c = await axios.get(`https://yervip.com/api/v1/leads-reports/init?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});

        await this.loadCountries(c.countries);
        this.main_results = c;
        this.resource = c;
        await this.loadByStatus();
        // await this.loadByCountry();
        // await this.loadSkusByCountry();
        await this.loadLeadsCountByAccount();
        this.loading = false;
        res();
      });
    },

    async loadLeadsCountByAccount() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const leadsData = await axios.get(`https://yervip.com/api/v1/leads-reports/aggregate_count_by_account?${this.buildFilter()}`).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        this.leadsCountByAccount = leadsData.data;
        this.loading = false;
        res();
      });
    },

    async exportLeads() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        const endpoint = `https://yervip.com/api/v1/leads-reports/export_leads?${this.buildFilter()}`;
        const exp = await axios.get(endpoint).then((x) => x.data).catch(err=>{console.log(err); res(true)});
        if (!exp.data.length) {
          this.$emit('snackbarNotification', this.i18n['no_data_to_export'], 'info');
        } else {
          this.exportSimpleData(exp.data, 'leads_count');
        }
        this.loading = false;
        res();
      });
    },

    loadMoreLeadsHandler() {
      if (this.totalLeadsToShow < this.leadsCountByAccount.length) {
        this.totalLeadsToShow += 2;
      }
    },
    async loadAccounts() {
      return new Promise(async (res, rej) => {
        const c = await axios.get(`https://yervip.com/api/v1/leads-reports/get_accounts?${this.buildFilter()}`).then((x) => x.data).catch(err => { console.log(err); res(true) });
        this.resource = c;
        res();
      });
    },
  },
  computed: {
    statuses_obj() {
      return this.$store.state.statuses_obj;
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    api() {
      return this.$store.state.settings.apiBase;
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path == this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    canLoadMoreLeads() {
      return this.totalLeadsToShow < this.leadsCountByAccount.length;
    },
  },
  async created(){
    await this.loadAccounts()
  }
};
</script>

<style>
.statCard {
  border-top: solid 5px #9f0019 !important;
  border-bottom: solid 3px #9f0019 !important;
}
</style>
